import { UtilityService } from "./index";

class CostingServices {
  async listCostings(page, sampleRequestId) {

    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/getCostingList",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          page: page,
          sampleRequestId: sampleRequestId
        })
      }
    );
    return {
      text: await result.json(),
      status: result.status
    };
  }

  async removeCosting(id) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/deleteCostingById",
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          _id: id
        })
      }
    );
    return {
      text: await result.json(),
      status: result.status
    };
  }
  async cloneCostings(id) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/cloneCosting",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          _id: id
        })
      }
    );
    return result.json();
  }

  async addCosting(data) {

    let result = await fetch(UtilityService.baseUrl() + "api/costing/saveCosting", {
      method: "PUT",
      headers: {
        'Accept': "application/json",
        "Content-Type": "application/json",
        'AuthToken': localStorage.getItem("authToken")
      },
      body: JSON.stringify(data)
    });
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async editCosting(data, state, id) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/saveCosting",
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          _id: id,
          styleRefNumber:
            state.styleInfo !== undefined && state.styleInfo.styleReferenceId,
          customer: state.customerInfo._id,
          customerDeptId: state.department._id,
          magnumStyleId: state.styleInfo.magnumStyleId,
          sampleRequestId: state.sampleNo !== undefined && state.sampleNo.value,
          customerRefNo:
            state.customerInfo !== undefined && state.customerInfo.customerId,
          fabricType: state.costingFullInfo.fabricType,
          buyerName: state.costingFullInfo.buyerName,
          setBoolean: state.set,
          doneBy: state.costingFullInfo.doneBy,
          createdBy: state.costingFullInfo.createdAt,
          orderDate: state.costingFullInfo.createdAt,
          modifiedBy: state.modifiedBy,
          fabricCostDetails: data[0],
          trimCostDetails: data[1],
          embroderyCostDetails: data[2],
          washDetails: data[3],
          manufacturingAndPieceCost: data[4],
          otherPieceCostDetails: data[5],
          smvCalculation: data[6],
          retailMargin: data[7],
          ratioCosting: data[8]
        })
      }
    );
    return result.json();
  }

  async getCostingInfo(id) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/getCostingById",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          _id: id
        })
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  //search costing and listing
  async searchCosting(searchBy, searchVal, page) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/searchCostinglist",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          for: searchVal,
          by: searchBy,
          page: page
        })
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async getSampleRequestInfo(value) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/getSampleRequestInfo",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          requestId: value
        })
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async getCostingSystem() {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/prefilledValues",
      {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        }
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async getTrimPackByCustomer(customer, customerDepartmentId) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/getTrimPack",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          customer,
          customerDepartmentId
        })
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async getSupplierSectionFabric(fabricId) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/getSupplier/fabric",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          fabricId: fabricId
        })
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async getSupplierSectionTrim(trimId) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/getSupplier/trim",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          trimId: trimId
        })
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async costingNumber() {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/generateCostingId",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        }
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async costingCompare(ids) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/costing/compareCostings",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          ids: ids
        })
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }


}
export default new CostingServices();



// WEBPACK FOOTER //
// ./src/services/costing.service.js